import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteBoxFloatProgramV2Component} from './website-box-float-program-v2.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'
import {RouterModule} from '@angular/router'
import {NgxJsonLdModule} from 'ngx-json-ld'
import {RichsnipetService} from 'dmmp-services'
import {RemoveHtmlPipe} from '../../pipes/removeHtml.pipe'
import {PipesModule} from '../../pipes/pipes.module'

@NgModule({
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        SharedModule,
        RouterModule,
        NgxJsonLdModule,
        PipesModule
    ],
  declarations: [WebsiteBoxFloatProgramV2Component],
    exports: [
        WebsiteBoxFloatProgramV2Component
    ],
  providers: [RichsnipetService, RemoveHtmlPipe]
})
export class WebsiteBoxFloatProgramV2Module {
}
